import { DocumentStatuses } from 'commons/types/DTO/commons'
import { TextBadge } from 'ui/components'

export const ClientDocumentStatus = (props: { name: string }) => {
  const { name } = props

  switch (name.toLowerCase()) {
    case DocumentStatuses.APPROVED:
      return (
        <TextBadge color="positive" data-qa="document-period-status">
          Accepted
        </TextBadge>
      )
    case DocumentStatuses.REJECTED:
      return (
        <TextBadge color="error" data-qa="document-period-status">
          Rejected
        </TextBadge>
      )
    case DocumentStatuses.INCOMPLETE:
      return (
        <TextBadge color="error" data-qa="document-period-status">
          Incomplete
        </TextBadge>
      )
    case DocumentStatuses.NEW:
      return (
        <TextBadge color="default" data-qa="document-period-status">
          Upcoming
        </TextBadge>
      )
    case DocumentStatuses.PENDING_APPROVAL:
      return (
        <TextBadge color="default" data-qa="document-period-status">
          Pending Approval
        </TextBadge>
      )
    case DocumentStatuses.PENDING_UPLOAD:
      return (
        <TextBadge color="default" data-qa="document-period-status">
          Pending Upload
        </TextBadge>
      )
  }

  return (
    <TextBadge color="default" data-qa="document-period-status">
      {name}
    </TextBadge>
  )
}
